import React, { useState, useEffect, useCallback } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import '../styles/TestimonialsSection.css';

const testimonials = [
  {
    id: 1,
    name: "Shahnawaz Quazi",
    photo: "/assets/images/Shahnawaz-Ainuddin.png",
    feedback: "QuantumFrame Studio delivered an exceptional website that perfectly showcases our gym equipment manufacturing business. Their attention to detail and professional approach helped us establish a strong online presence."
  },
  {
    id: 2,
    name: "Sajid Ali",
    photo: "/assets/images/Sajid-ali.jpeg",
    feedback: "Working with QuantumFrame Studio was a great experience. They created a beautiful and functional website that has significantly improved our travel agency's booking rates and customer engagement."
  },
  {
    id: 3,
    name: "Mr Riyaz",
    photo: "/assets/images/mtcl.jpg",
    feedback: "The team at QuantumFrame Studio understood our vision perfectly. The website they created has helped us reach more customers and streamline our booking process. Highly recommended!"
  },
  {
    id: 4,
    name: "Mr Obito",
    photo: "/assets/images/obito.jpg",
    feedback: "QuantumFrame Studio's expertise in content management and video production has been instrumental in growing my YouTube channel. Their creative solutions and professional service exceeded my expectations."
  },
];

const TestimonialsSection = () => {
  const controls = useAnimation();
  const [position, setPosition] = useState(0);
  const cardWidth = 300; // Width of each card
  const gap = 30; // Gap between cards
  const totalWidth = testimonials.length * (cardWidth + gap);

  const updatePosition = useCallback((newPosition) => {
    if (newPosition > 0) {
      setPosition(-totalWidth + (cardWidth + gap));
    } else if (newPosition < -totalWidth) {
      setPosition(0);
    } else {
      setPosition(newPosition);
    }
  }, [totalWidth, cardWidth, gap]);

  useEffect(() => {
    const autoRotate = setInterval(() => {
      updatePosition(position - (cardWidth + gap));
    }, 5000);
    
    return () => clearInterval(autoRotate);
  }, [position, updatePosition, cardWidth, gap]);

  useEffect(() => {
    controls.start({
      x: position,
      transition: {
        ease: "linear",
        duration: 0.5,
      },
    });
  }, [position, controls]);

  const handleDragEnd = (event, info) => {
    updatePosition(position + info.offset.x);
  };

  return (
    <section className="testimonials-section">
      <div className="container">
        <h2 className="section-title">What Our Clients Say</h2>
        <div className="carousel-wrapper">
          <motion.div
            className="testimonial-carousel"
            animate={controls}
            drag="x"
            dragConstraints={{ left: -totalWidth, right: 0 }}
            onDragEnd={handleDragEnd}
            style={{
              width: `${totalWidth * 2}px`,
            }}
          >
            {[...testimonials, ...testimonials].map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="testimonial-content">
                  <img
                    src={testimonial.photo}
                    alt={testimonial.name}
                    className="testimonial-photo"
                  />
                  <h3 className="testimonial-name">{testimonial.name}</h3>
                  <p className="testimonial-feedback">{testimonial.feedback}</p>
                  <a
                    href="/testimonials"
                    className="read-more"
                  >
                    Read More 
                    <ArrowRight className="arrow-icon" />
                  </a>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
        <div className="view-more-wrapper">
          <a href="/testimonials" className="view-more">
            View More Testimonials
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;